// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/chat/chat.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_annotations } from "../core/annotations_pb";

/**
 * Describes the file proto/model/chat/chat.proto.
 */
export const file_proto_model_chat_chat = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_proto_model_core_annotations]);

/**
 * Describes the message carmen.Thread.
 * Use `create(ThreadSchema)` to create a new message.
 */
export const ThreadSchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 0);

/**
 * Describes the message carmen.ThreadDisplay.
 * Use `create(ThreadDisplaySchema)` to create a new message.
 */
export const ThreadDisplaySchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 1);

/**
 * Describes the message carmen.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 2);

/**
 * Describes the message carmen.TextContent.
 * Use `create(TextContentSchema)` to create a new message.
 */
export const TextContentSchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 3);

/**
 * Describes the message carmen.ToolCall.
 * Use `create(ToolCallSchema)` to create a new message.
 */
export const ToolCallSchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 4);

/**
 * Describes the message carmen.ToolResponse.
 * Use `create(ToolResponseSchema)` to create a new message.
 */
export const ToolResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 5);

/**
 * Describes the message carmen.AgentError.
 * Use `create(AgentErrorSchema)` to create a new message.
 */
export const AgentErrorSchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 6);

/**
 * Describes the message carmen.StreamMessageChunk.
 * Use `create(StreamMessageChunkSchema)` to create a new message.
 */
export const StreamMessageChunkSchema = /*@__PURE__*/
  messageDesc(file_proto_model_chat_chat, 7);

/**
 * Describes the enum carmen.Role.
 */
export const RoleSchema = /*@__PURE__*/
  enumDesc(file_proto_model_chat_chat, 0);

/**
 * Role identifies who is speaking in the conversation
 *
 * @generated from enum carmen.Role
 */
export const Role = /*@__PURE__*/
  tsEnum(RoleSchema);

/**
 * Describes the enum carmen.CompositionStatus.
 */
export const CompositionStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_chat_chat, 1);

/**
 * CompositionStatus indicates the status of a message composition
 * either by the user or the AI agent.
 *
 * @generated from enum carmen.CompositionStatus
 */
export const CompositionStatus = /*@__PURE__*/
  tsEnum(CompositionStatusSchema);

/**
 * Describes the enum carmen.ChunkType.
 */
export const ChunkTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_chat_chat, 2);

/**
 * Type of chunk being streamed
 *
 * @generated from enum carmen.ChunkType
 */
export const ChunkType = /*@__PURE__*/
  tsEnum(ChunkTypeSchema);

